import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const ASPECTS = ["aspect-[4/5]", "aspect-[1/1]", "aspect-[3/4]", "aspect-[5/6]"];

export const ScentWall = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/products")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  // We show up to 50 tiles. If fewer products exist, cycle them.
  const N = 50;
  const tiles = Array.from({ length: N }, (_, i) => {
    const p = items[i % items.length];
    return {
      url: p.image_url,
      name: p.name,
      id: p.id,
      aspect: ASPECTS[i % ASPECTS.length],
      n: i + 1,
    };
  });

  return (
    <section
      data-testid="scent-wall-section"
      className="border-y border-[#2D2622]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="flex items-end justify-between mb-14 md:mb-20 gap-6 flex-col md:flex-row">
          <div>
            <p className="text-[11px] tracking-overline uppercase font-bold text-[#D4AF37] mb-4">
              № 04 — The wall of scent
            </p>
            <h2 className="font-serif-display font-light text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight text-[#F4EAD9]">
              Fifty bottles, <span className="italic text-[#D4AF37]">one mood</span>.
            </h2>
          </div>
          <p className="max-w-xs text-sm text-[#B0A496] leading-relaxed">
            A scrolling archive of every flacon photographed in the atelier this year.
            Hover any tile to enter the story.
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-8 lg:grid-cols-10 gap-2 md:gap-3">
          {tiles.map((t, i) => (
            <Link
              key={i}
              to={`/product/${t.id}`}
              data-testid={`scent-wall-tile-${i}`}
              className={`relative image-zoom-parent overflow-hidden group bg-[#1F1A17] ${t.aspect}`}
            >
              <img
                src={t.url}
                alt={t.name}
                loading="lazy"
                className="image-zoom absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#000000]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="absolute bottom-1.5 left-2 right-2 text-[9px] tracking-overline uppercase font-bold text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-500 truncate">
                {t.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScentWall;
